import Swal from 'sweetalert2'

export const help = (e, title, msj) => {
  e.preventDefault();
  Swal.fire({
    title: `<strong>${title}</strong>`,
    icon: "info",
    html: `
      ${msj}
    `,
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: `
      Aceptar
    `,
    confirmButtonAriaLabel: "Aceptar",
  });
}

